/* Abracadavoix – lecteurs audio (extraits) */
(function () {
  var PLAY = 'M8.5 5.2v13.6L19 12z';
  var PAUSE = 'M6.5 4.5h4v15h-4zM13.5 4.5h4v15h-4z';
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); var m = Math.floor(s / 60), r = s % 60; return m + ':' + (r < 10 ? '0' : '') + r; }

  function init(root) {
    if (root.dataset.abvReady) return;
    root.dataset.abvReady = '1';
    var audio = root.querySelector('audio');
    var btn = root.querySelector('[data-abv-toggle]');
    var path = btn && btn.querySelector('path');
    var bar = root.querySelector('[data-abv-bar]');
    var cur = root.querySelector('[data-abv-current]');
    var dur = root.querySelector('[data-abv-duration]');
    if (!audio || !btn) return;

    function paint() {
      var d = audio.duration && isFinite(audio.duration) ? audio.duration : Number(bar && bar.max) || 0;
      if (bar) {
        bar.max = Math.floor(d) || bar.max;
        bar.value = Math.floor(audio.currentTime);
        bar.style.setProperty('--abv-p', d ? (audio.currentTime / d * 100) + '%' : '0%');
      }
      if (cur) cur.textContent = fmt(audio.currentTime);
      if (dur && d) dur.textContent = fmt(d);
    }
    function state() {
      var on = !audio.paused;
      if (path) path.setAttribute('d', on ? PAUSE : PLAY);
      btn.setAttribute('aria-label', on ? 'Mettre en pause' : (btn.dataset.abvLabel || 'Écouter l’extrait'));
    }
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-abv-player] audio').forEach(function (a) { if (a !== audio) a.pause(); });
      if (audio.paused) { audio.play(); } else { audio.pause(); }
    });
    root.querySelectorAll('[data-abv-skip]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = audio.duration || 0;
        audio.currentTime = Math.min(Math.max(0, audio.currentTime + Number(b.dataset.abvSkip)), d || audio.currentTime);
        paint();
      });
    });
    if (bar) bar.addEventListener('input', function () { audio.currentTime = Number(bar.value); paint(); });
    ['timeupdate', 'loadedmetadata', 'durationchange'].forEach(function (e) { audio.addEventListener(e, paint); });
    ['play', 'pause', 'ended'].forEach(function (e) { audio.addEventListener(e, state); });
    paint(); state();
  }

  function scan() { document.querySelectorAll('[data-abv-player]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

/* Abracadavoix – champs de dédicace affichés seulement pour la variante « Avec dédicace » */
(function () {
  function sync() {
    document.querySelectorAll('[data-abv-perso]').forEach(function (fs) {
      var form = document.getElementById(fs.dataset.form);
      var idInput = form && form.querySelector('input[name="id"]');
      var ids = (fs.dataset.dedicace || '').split(',').filter(Boolean);
      var on = !!(idInput && ids.indexOf(String(idInput.value)) !== -1);
      var box = fs.querySelector('[data-abv-dedicace]');
      if (!box) return;
      box.hidden = !on;
      box.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !on; el.required = on; });
    });
  }
  function later() { setTimeout(sync, 60); setTimeout(sync, 400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('change', later);
  document.addEventListener('variant:update', later);
  document.addEventListener('shopify:section:load', later);
})();

/* Abracadavoix – garde les réponses si le thème recharge la fiche lors d'un changement de variante */
(function () {
  var memo = {};
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (el.closest && el.closest('[data-abv-perso]') && el.name) memo[el.name] = el.type === 'checkbox' ? el.checked : el.value;
  });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.closest && el.closest('[data-abv-perso]') && el.name) memo[el.name] = el.type === 'checkbox' ? el.checked : el.type === 'radio' ? el.value : el.value;
  });
  function restore() {
    document.querySelectorAll('[data-abv-perso] [name]').forEach(function (el) {
      if (!(el.name in memo)) return;
      var v = memo[el.name];
      if (el.type === 'checkbox') el.checked = !!v;
      else if (el.type === 'radio') el.checked = el.value === v;
      else if (!el.value) el.value = v;
    });
  }
  ['variant:update', 'change'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(restore, 450); }); });
})();
